import { AiChatResourceType, AiSource } from "components/ai_chat/types";
import { AiResourceType } from "lib/core_components/ai/types";
import { AiSourceDocumentType } from "lib/types/graphQLEnums";

const getDocumentType = (type: AiSourceDocumentType) => {
  switch (type) {
    case "BID_DOCUMENT":
      return "Tender document";
    case "CONTENT_LIBRARY":
      return "Content library document";
  }
  return "";
};

export const createReferenceLinkOpenedEventPayload = ({
  source,
  resourceType,
  resourceId,
  bidId,
}: {
  source: AiSource;
  resourceType: AiResourceType | AiChatResourceType;
  resourceId?: string;
  bidId?: string;
}) => {
  const payload: Record<string, string> = {};
  switch (source.type) {
    case "document":
      payload["Reference type"] = getDocumentType(source.documentType);
      payload["Document GUID"] = source.id;
      break;

    case "notice":
      payload["Reference type"] = "Record";
      payload["Notice GUID"] = source.id;
      break;

    case "website":
      payload["Reference type"] = "Web URL";
      payload["Url"] = source.url;
      break;
  }

  switch (resourceType) {
    case "BUYER_QA":
      if (resourceId) payload["Buyer GUID"] = resourceId;
      break;

    case "BID_ASK_AI":
      if (resourceId) payload["Bid report ID"] = resourceId;
      if (bidId) payload["Bid ID"] = bidId;
      break;

    case "BID_WRITING_QA":
      if (bidId) payload["Bid ID"] = bidId;
      if (resourceId) payload["Bid response GUID"] = resourceId;
      break;

    case "CONTENT_LIBRARY_QA":
      break;

    case "BID_WIN_THEMES":
    case "REQUIREMENT_SUMMARY":
    case "QUALIFICATION_REPORT":
      if (bidId) payload["Bid ID"] = bidId;
      break;
  }
  return payload;
};
